import { z } from 'zod';

export const AddCustomerRoleBodySchema = z.object({
  notes: z.string().trim().nullable().optional(),
  referredByOrganizationGroupId: z.uuid().nullable().optional(),
});

export type AddCustomerRoleBody = z.infer<typeof AddCustomerRoleBodySchema>;

export const AddCustomerRoleResponseSchema = z.object({
  customerRoleId: z.uuid(),
});

export type AddCustomerRoleResponse = z.infer<typeof AddCustomerRoleResponseSchema>;
